<template>
  <div class="exam">
    <el-row>
      <el-col :span="24" class="topline">
        <div class="alignitems">
          <i class="el-icon-arrow-left backicon eee" @click="backlist">返回</i>
        </div>
      </el-col>
    </el-row>

    <el-row class="contant" v-if="current_subject">
      <el-col :span="24" >
          <div v-if="current_subject.subjectType=='1'" class="now_subject" >
            单选题
          </div>
          <div v-if="current_subject.subjectType=='2'" class="now_subject" >
            多选题
          </div>
          <div v-if="current_subject.subjectType=='3'" class="now_subject" >
            判断题
          </div>
      </el-col>

      <el-col :span="24">
           <!-- 当前题目 -->
          <div class="linh31" v-html="current_subject.subjectDes">
             {{current_subject.subjectDes}}
          </div>
      </el-col>

       <!-- 当前题目 -->
      <el-col :span="24"  v-if="current_subject.materialDecript">
        <div class="boxcard">
          <div class="linh31" v-html="current_subject.materialDecript">
             {{current_subject.materialDecript}}
          </div>
        </div>
      </el-col>

      <el-col :span="24" >
          <span class="ctitle" >正确选项为</span>
          <span class="flv" >{{current_subject.correctIndex}}</span>

             <span class="ctitle" >您的选择为</span>
            <span v-if="current_subject.correctIndex==current_subject.choseIndexList[0]" class="flv" >{{current_subject.choseIndexList[0]}}</span>
            <span v-if="current_subject.correctIndex!=current_subject.choseIndexList[0]"  class="fred" >{{current_subject.choseIndexList[0]}}</span>
      </el-col>

      <el-col :span="24" >
          <!-- 当前选项>-->
          <div class="now_abcd"
               v-for="item,index in current_subject.selections"
               :class="{greenactive:item.itemId==current_subject.correctItem,
                        redactive:item.itemId==current_subject.choseItem&&current_subject.choseItem!=current_subject.correctItem}"
               :id="item.itemIndex">

            <div class="left_abcd">
              <span>{{item.itemIndex}} </span>
            </div>
            <div class="right_abcd" v-html="item.itemDecript">
              {{item.itemDecript}}
            </div>

          </div>
      </el-col>



      <el-col  :offset="2" :span="20" class="mb5">
        <el-row>
          <el-col :span="12" class="center ddleft">
            <!-- current_subject.rightAcc.replace('%','') -->
            <el-progress type="circle" :percentage="60"></el-progress>
          </el-col>
          <el-col :span="12" class="nowap">
            <span class="dblck">本题已被做答
                <span class="yelab">{{current_subject.totalNum}}</span> 次
            </span>
            <span class="dblck">本题已有
                <span class="yelab">{{current_subject.rightNum}}</span>人做对
            </span>
            <span class="dblck" v-if="current_subject.confoundIndex">易错项为
                <span class="yelab">{{current_subject.confoundIndex}}</span>选项
            </span>
            <span class="dblck" v-if="!current_subject.confoundIndex">
                本题没有易错选项
            </span>
          </el-col>
        </el-row>
      </el-col>


      <!-- 解析 -->
      <el-col :span="24" class="">
          <div class="analysis linh31 f14"  v-html="current_subject.analysis">
              {{current_subject.analysis}}
          </div>
      </el-col>
       <el-col :span="24" class="">
          <div class="center downbtn">
            <button class="btndown mgauto">
              {{current_subject.exaPoint}}
            </button>
          </div>
          <div class="center ">
            <div class="subtitle mgauto">
                {{current_subject.source}}
            </div>
          </div>
      </el-col>
    </el-row>
    <div v-if="!current_subject"
            v-loading="loading"
            class="h100">
    </div>
  </div>
</template>

<script>
import { api_analysis_info } from "../../networks/DryRun.js"

export default {
  name: 'exam',
  data () {
    return {
      loading: true, //
      userid:'',     //
      greenactive:-1,     //选对
      redactive:-1,       //选错
      current_subject:[],       //自己选的答案
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    router_subjectId() {//题目id
      return this.$route.params.subjectId
    },
  },
  created: function () {
    var context = this;
    var user_id = context.user.user_id;
    var subjectId = context.router_subjectId;

    //1.请求网络层
    var promise = api_analysis_info(context,user_id,subjectId);
    //2.更新返回数据
    promise.then(function(data) {
        var materialDecript= data.data.result.subjectAnalysisInfo[0].materialDecript;
        var subjectDes= data.data.result.subjectAnalysisInfo[0].subjectDes;
        var analysis= data.data.result.subjectAnalysisInfo[0].analysis;
         //显示材料图片
        if(materialDecript.indexOf('src="') != -1){
           var str=materialDecript.split('src="');
           data.data.result.subjectAnalysisInfo[0].materialDecript=str[0]+'src="http://115.159.122.45/'+str[1];
        }
        //显示题目图片
        if(subjectDes.indexOf('src="') != -1){
           var sub=subjectDes.split('src="');
           data.data.result.subjectAnalysisInfo[0].subjectDes=sub[0]+'src="http://115.159.122.45/'+sub[1];
        }
        //显示答案图片
        if(analysis.indexOf('src="') != -1){
           var analy=analysis.split('src="');
           data.data.result.subjectAnalysisInfo[0].analysis=analy[0]+'src="http://115.159.122.45/'+analy[1];
        }
        //current_subject.analysis



        context.current_subject=data.data.result.subjectAnalysisInfo[0];


      $("#"+context.current_subject.correctIndex).addClass('greenactive');
      if(context.current_subject.correctIndex!=context.current_subject.choseIndexList[0]){
         $("#"+context.current_subject.choseItem).addClass('redactive');
      }



    }).catch(function(error){
    });

  },
  methods: {
    backlist: function() {//退回首页
      var context = this;
      context.subject_Exam=[];
      context.$router.go(-1);
      //this.$router.push({ path: '/'});
      clearInterval(this.chat_timer);
    },
  }
}
</script>

<style>

</style>

<style scoped>
.exam{
    width: 60%;
    margin: 0 auto;
}
.h100{
  min-height:676px;
  height:100%;
}
.topbtn{
    width: 100%;
    position: fixed;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content:space-between;
    background-color:#fff;
    right: 0px;
    bottom: 0px;
}
.btnsm{
    height: 30px;
    font-size: 12px;
    line-height: 4px;
    background-color: #ffbc40;
    color: #fff;
}
.fxicon{
      width: 25px;
    margin-left: 10px;
}
.topline{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:5px;
  right: 0px;
  top: 0px;
  z-index: 800;
  background-color:#fff;
}
.alignitems{
  display: flex;
   align-items: center;
}
.backicon{
  width:54px;
  height:30px;
  display: flex;
  align-items: center;
  justify-content: center;
      font-weight: 900;
          cursor: pointer;
}
.now_subject{
  margin-top:10px;
  margin-bottom:10px;
   color:#606266;
}
.contant{
  padding: 0 10px;
}

.ctitle{
    margin: 10px 0;
    font-size: 14px;
    color: #aaa;
}
.now_abcd{
    border: 1px solid #c0c4cc;
    border-radius: 9px;
    margin-bottom: 8px;
    display: flex;
    color:#606266;
    margin-top:10px;
}
.fs{
  color:#606266;
      margin-right: 10px;
    font-size: 14px;
}
.left_abcd{
    width: 30px;
    background-color: #ebeef5;
    border-top-left-radius:8px;
    border-bottom-left-radius:8px;
     display: flex;
     align-items: center;
     justify-content: center;
}
.right_abcd{
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 11px;
}
.hide{
  display:none;
}
.active{
  background-color: #f9f9eb;
}
.active >.left_abcd{
  background-color: #f3d334;
  color: #fff;
}
.redactive{
  background-color: #FFBFBD;
}
.redactive >.left_abcd{
  background-color: #E26D4F;
  color: #fff;
}
.greenactive{
  background-color: #f0f9eb;
}
.greenactive >.left_abcd{
  background-color: #a1d64c;
  color: #fff;
}
.eee{
   color: #606266;
}

.flv{
  color: #a1d64c;
}
.fred{
 color: #E26D4F;
}
.btndown{
    height: 30px;
    font-size: 12px;
    line-height: 5px;
    background-color: #fff;
        color: #606266;
}
.linh31{
  line-height:31px!important;
  overflow: scroll;
  color: #606266;
}
.center{
  display: flex;
}
.btnlg{
  margin: 10px auto;
  height: 46px;
  width: 150px;
  font-size: 16px;
  line-height: 5px;
  background-color: #ffbc40;
  color: #fff;
  border: 0px solid #dcdfe6;
}
.mgauto{
  margin: 10px auto;
}
.subtitle{
  font-size: 12px;
    color: #aaa;
    margin-top:10px;
    margin-bottom:40px;
}

.yelab{
  color: #fdbc3f;
}
.f14{
   font-size: 14px;
}
.dblck{
  display: block;
  font-size:14px;
  margin-top:12px;
      color: #606266;
}
#box{
  display: flex;
    border: 1px solid #eee;
    border-radius: 5px;
    font-size: 13px;
    margin-left: 10px;
    margin-right:10px;
    height: 25px;
    width:77px;
    color:#aaa;
      display: flex;
     align-items: center;
}
#box p{
  margin:5px;
}
.boxcard{
  background-color:#f5f5f5;
  padding:5px;
  height:150px;
  overflow:auto;
}
.downbtn{
    width: 50%;
    margin: 0px auto;
    border-top: 1px solid #eee;
}
.analysis{
  margin-bottom:5px;
}
.bottom__text{
    position: absolute;
    top: 67%;
    left: 0;
    width: 100%;
    text-align: center;
    margin: 0;
    -webkit-transform: translate(0,-50%);
    transform: translate(0,-50%);
}
.nowap{
  white-space:nowrap;
}
.mb5{
  margin-bottom:5px;
}
.ddleft{
      margin-top: 3%;
    padding-left: 20%;
}
</style>





// WEBPACK FOOTER //
// src/components/DryRun/subjectId.vue